/**
 * Marks an element (and everything nested inside it) as carrying customer
 * data. Mixpanel still records the click, dead click, rage click or scroll —
 * only the element's text and attributes are left out.
 */
export const SENSITIVE_CLASS_NAME = 'mp-sensitive';

/**
 * Prefix of the class `analyticsName` adds. Mixpanel records every ancestor's
 * classes even on sensitive elements, so the prefixed class is the one way a
 * hidden control can still say what it is.
 */
export const ELEMENT_NAME_CLASS_PREFIX = 'el-name-';

/**
 * Class names that give a control a stable `element_name` on its autocaptured
 * clicks. `name` is a categorical kebab-case code, never customer data, and
 * renaming it breaks saved reports. Pass `sensitive: true` on any control that
 * renders customer data — it replaces `SENSITIVE_CLASS_NAME`, so without it the
 * control's text is captured.
 */
export const analyticsName = (name: string, { sensitive = false } = {}): string =>
  sensitive
    ? `${SENSITIVE_CLASS_NAME} ${ELEMENT_NAME_CLASS_PREFIX}${name}`
    : `${ELEMENT_NAME_CLASS_PREFIX}${name}`;
